import { ProgressCard } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { useMedia, View } from "tamagui";

import type { RouterOutputs } from "~/utils/api";

type GetHomeInfoReturnType = RouterOutputs["home"]["getHomeInfo"];
export type PreviousResultsData = Omit<
  GetHomeInfoReturnType,
  "recommendations"
>;

export const PreviousResults: React.FC<{
  data: PreviousResultsData;
}> = ({ data }) => {
  const { t } = useTranslation("homePage");
  const { sm } = useMedia();
  return (
    <ProgressCard.Container>
      <View gap={"$1"}>
        <ProgressCard.Title data-id="hmt-index-title" font={sm ? "md" : "lg"}>
          {t("hmt_index.title", { date: data.lastDiagnosticDate })}
        </ProgressCard.Title>

        <View data-id={"diagnostic-interpretation"}>
          <ProgressCard.Description md={data?.description} />
        </View>
      </View>
    </ProgressCard.Container>
  );
};
